export const rabbySvg = (
  <svg viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.81 21.3663C40.294 18.0374 32.9143 8.69253 25.8555 4.84226C21.4036 1.83424 16.7913 2.23531 15.8288 3.55884C13.7833 6.44654 22.6469 8.93317 28.5828 11.7808C27.2994 12.3423 26.0961 13.3449 25.4143 14.5882C23.2084 12.1818 18.3555 10.0963 12.6603 11.7808C8.81004 12.9038 5.6416 15.5909 4.39828 19.6016C4.11753 19.4813 3.75657 19.4011 3.43571 19.4011C2.11218 19.4011 1.0293 20.484 1.0293 21.8075C1.0293 23.131 2.11218 24.2139 3.43571 24.2139C3.67636 24.2139 4.43839 24.0535 4.43839 24.0535L16.7913 24.1337C11.8582 31.9947 7.92769 33.1177 7.92769 34.4813C7.92769 35.8449 11.6576 35.484 13.0614 34.9626C19.7994 32.5562 27.0186 24.9759 28.2619 22.8102C33.4758 23.492 37.8475 23.5321 38.81 21.3663Z"
      fill="url(#paint0_linear_8225_3012)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.6231 11.7808C28.9039 11.6604 28.8638 11.2594 28.7835 10.9385C28.6231 10.2166 25.6151 7.24867 22.8076 5.92514C18.9573 4.12033 16.1498 4.20054 15.7488 5.04279C16.5108 6.64707 20.1605 8.13103 23.9306 9.7353C25.4948 10.377 27.1392 11.0588 28.6231 11.7808Z"
      fill="url(#paint1_linear_8225_3012)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7299 27.9038C22.9679 27.623 22.0855 27.3423 21.0828 27.1016C22.1256 25.2166 22.3663 22.369 21.3636 20.6043C19.9599 18.1177 18.1951 16.7941 14.0641 16.7941C11.8181 16.7941 5.72188 17.5562 5.60156 22.6497C5.60156 23.1711 5.60156 23.6524 5.64167 24.1337H16.7914C15.3074 26.5 13.9037 28.2647 12.6604 29.5882C14.1443 29.9492 15.3475 30.2701 16.4705 30.5909C17.5133 30.8717 18.516 31.1123 19.5187 31.3931C21.0427 30.2701 22.4866 29.0669 23.7299 27.9038Z"
      fill="url(#paint2_linear_8225_3012)"
    />
    <path
      d="M4.23791 23.5321C4.67909 27.3823 6.88497 28.9064 11.3769 29.3476C15.8689 29.7888 18.4358 29.508 21.8449 29.7888C24.6925 30.0294 27.2593 31.5134 28.1818 30.992C29.024 30.5508 28.5427 28.9064 27.4197 27.8636C25.9358 26.5 23.8903 25.5775 20.3208 25.2166C21.0427 23.2513 20.8422 20.4839 19.7192 19C18.1149 16.8342 15.147 15.8716 11.3769 16.2727C7.44647 16.754 3.67641 18.7192 4.23791 23.5321Z"
      fill="url(#paint3_linear_8225_3012)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8225_3012"
        x1="12.2523"
        y1="18.2604"
        x2="38.5409"
        y2="25.7154"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8797FF" />
        <stop offset="1" stopColor="#AAA8FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8225_3012"
        x1="33.1384"
        y1="18.849"
        x2="14.17"
        y2="-0.16586"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3B22A0" />
        <stop offset="1" stopColor="#5156D8" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8225_3012"
        x1="24.2533"
        y1="28.591"
        x2="6.03203"
        y2="18.1151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3B1E8F" />
        <stop offset="1" stopColor="#6A6FFB" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8225_3012"
        x1="10.9825"
        y1="20.4224"
        x2="23.2987"
        y2="36.0715"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8898FF" />
        <stop offset="0.9839" stopColor="#5F47F1" />
      </linearGradient>
    </defs>
  </svg>
)
